var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.335,
    height: 23.335,
    viewBox: "0 0 23.335 23.335",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.668 -6.011) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 25,
    transform: "translate(12.5 0)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y1: 25,
    transform: "translate(25 12.5) rotate(90)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.d2be0fad.svg";
export { ForwardRef as ReactComponent };